export enum QuestionType {
  Slider = "Slider",
  Dropwdown = "Dropwdown",
  MultipleChoice = "MultipleChoice",
  Illustration = "Illustration",
}
